import React, { useContext, useEffect, useState } from "react";
import { CreateArtifactContext } from "../../../context/CreateArtifactContext";
import { useNavigate } from "react-router-dom";
import { useNavigationBar } from "../../../context/NavigationContext";
import LoadingPopup from "../../channels/create/LoadingPopup";

const CertifyContent = () => {
  const [isLoading, setIsLoading] = useState(false);
  const { contentData, updateContentData } = useContext(CreateArtifactContext);
  const { setNavProps } = useNavigationBar();
  const navigate = useNavigate();

  useEffect(() => {
    setNavProps({
      backArrow: false,
      title: "Content",
      subtitle: "Channel",
      buttonTitle: "Done",
      filterOption: false,
      enableLink: (contentData.certifySecond ?? false) && (contentData.certifyFirst ?? false),
      onFilter: () => {},
      onNext: () => navigate(-1),
      onClose: () => navigate(-1),
      getActionItems: undefined,
    });
  }, [setNavProps, contentData, navigate]);

  const renderDescription = (description: string) => {
    return description.split(/(\*.*?\*)/g).map((part, index) => {
      if (part.startsWith("*") && part.endsWith("*")) {
        return (
          <span key={index} className="font-bold">
            {part.slice(1, -1)}
          </span>
        );
      }
      return part;
    });
  };

  return (
    <div className="p-1 bg-white">
      <LoadingPopup isLoading={isLoading} />
      <div className="flex flex-col">
        <div className="flex flex-col w-full">
          <div className="flex flex-col w-full">
            <label className="title_inner_page">Certify Content</label>
            <label className="notes-class-content">Certify that your channel would ensure and comply with these requirements.</label>
          </div>
          <div className="pt-[15px] pb-[15px]">
            <label className="custom-checkbox mb-[15px]">
              <input
                name="primary"
                className="mr-5"
                type="checkbox"
                checked={contentData.certifyFirst ?? false}
                onChange={() => {
                  updateContentData({
                    ...contentData,
                    certifyFirst: !contentData.certifyFirst,
                  });
                }}
              />
              <span>{renderDescription("I certify that this channel's content does *NOT* contain:")}</span>
              <span className="checkmark"></span>
            </label>
            <div className="flex flex-col ml-8 gap-[10px]">
              <label className="content-rating-all-item">1. Violence or Gore</label>
              <label className="content-rating-all-item">2. Hate Speech or Discrimination</label>
              <label className="content-rating-all-item">3. Harassment or Bullying</label>
              <label className="content-rating-all-item">4. Nudity or Sexual Content</label>
              <label className="content-rating-all-item">5. Misleading Information or Spam</label>
              <label className="content-rating-all-item">6. Abusive or Exploitive Content</label>
              <label className="content-rating-all-item">7. Privacy Violation</label>
              <label className="content-rating-all-item">8. Copyright Infringement or Illegal Content</label>
            </div>
          </div>
          <div className="thinseparator"></div>
          <div className="flex flex-col pt-[15px] pb-[15px]">
            <label className="custom-checkbox max-w-[480px]">
              <input
                name="secondary"
                className="mr-5"
                type="checkbox"
                checked={contentData.certifySecond ?? false}
                onChange={() => {
                  updateContentData({
                    ...contentData,
                    certifySecond: !contentData.certifySecond,
                  });
                }}
              />
              <span>
                {renderDescription(
                  "I certify that this channel’s content is safe, accurate, respectful, legal, protects people’s privacy and follows *Skarvo Community Guidelines.*"
                )}
              </span>
              <span className="checkmark"></span>
            </label>
          </div>
          <div className="certificate-separator"></div>
        </div>
      </div>
    </div>
  );
};

export default CertifyContent;
